/**
* 通知实时推送
*/
const messageServer = {

  allotMessageRealtimeNotifyServer: "/api/allotMessageRealtimeNotifyServer",//分配（获取）一个事件（告警）实时推送服务器
}

export default messageServer